/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { useQuery } from '@tanstack/react-query';
import { createLayoutQueryOptions } from '../queries/layout.query';
import { useAppConfig } from '@airasia-rn/ui/config';
import { DEFAULT_LANGUAGE } from '@airasia-rn/ui/localization';

export const useLayoutData = (
  apiKey: string,
  enabled: boolean = true,
  slug?: string,
) => {
  const { config } = useAppConfig();
  return useQuery({
    ...createLayoutQueryOptions({
      env: (config.env as string) || 'stg',
      apiKey,
      locale: config.locale || DEFAULT_LANGUAGE,
      geoId: config.geoId,
      slug,
    }),
    enabled,
  });
};
